import { useDispatch } from 'react-redux'
import { updateQuery as updateQueryAction, resetOwnersList } from '../../stores/ticketsScanner/actions'

const TicketsScannerSearchAutocompleteItem = ({ barcode, name, email, highlight, onSelect }) => {
  const dispatch = useDispatch()

  const handleClick = () => {
    dispatch(updateQueryAction(barcode))
    dispatch(resetOwnersList())
    // resetOwnersList unmounts this row. Without this the focus it held would fall to the
    // document body, stranding anyone who got here with the keyboard.
    if (onSelect) onSelect()
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      handleClick()
    }
  }

  let className = "autocomplete-item"
  if (highlight) {
    className += " active"
  }

  return (
    <div
      className={className}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <div className="row">
        <div className="col-xs-2 text-center">
          <h3 className="barcode">{barcode}</h3>
        </div>
        <div className="col-xs-10">
          <h3
            className="name"
            dangerouslySetInnerHTML={{ __html: name }}
          ></h3>
          <p>{email}</p>
        </div>
      </div>
    </div>
  )
}

export default TicketsScannerSearchAutocompleteItem
